import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import profilePic from '../assets/images/profilepic.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profilePic} alt="Adam Wong" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/AtomWo" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/adam-wong-09061b22b/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Adam Wong</h1>
          <p>Electrical Engineer @ UC Davis</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/AtomWo" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/adam-wong-09061b22b/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;